import { useEffect, useState } from 'react'

const useBrowserFingerprint = () => {
  const [fingerprint, setFingerprint] = useState(null)

  useEffect(() => {
    const getBrowserData = () => {
      const innerMatchesScreen =
        window.innerWidth === window.screen.width &&
        window.innerHeight === window.screen.height

      const outerMatchesScreen =
        window.outerWidth === window.screen.width &&
        window.outerHeight === window.screen.height

      // Safari might make all window/screen sizes equal for fingerprinting protection
      const windowScreenReliable = !(innerMatchesScreen && outerMatchesScreen)

      return {
        userAgent: navigator.userAgent,
        platform: navigator.platform,
        language: navigator.language,
        screenWidth: windowScreenReliable ? window.screen.width : 0,
        screenHeight: windowScreenReliable ? window.screen.height : 0,
        colorDepth: window.screen.colorDepth,
        timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
        cpuCores: navigator.hardwareConcurrency || 'unknown',
        touchSupport: navigator.maxTouchPoints > 0 ? 'yes' : 'no'
      }
    }

    const generateHash = async (input) => {
      const msgUint8 = new TextEncoder().encode(JSON.stringify(input))
      const hashBuffer = await crypto.subtle.digest('SHA-256', msgUint8)
      const hashArray = Array.from(new Uint8Array(hashBuffer))
      return hashArray
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('')
    }

    const createFingerprint = async () => {
      const data = getBrowserData()
      const hash = await generateHash(data)
      setFingerprint(hash)
    }

    createFingerprint()
  }, [])

  return fingerprint
}

export default useBrowserFingerprint
